import * as React from "react"
import { useForm, FormProvider } from "react-hook-form"
import { Box, Button, InputAdornment } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import { TextInput, NullableBooleanInput, useListContext, SelectInput, ReferenceInput, BooleanInput } from "react-admin"
import { useEffect } from "react"

const CategoryFilterForm = () => {
  const {
    displayedFilters,
    filterValues,
    setFilters,
    hideFilter
  } = useListContext()

  const form = useForm({
    defaultValues: {
      ...filterValues,
      q: filterValues.q || ''
    }
  });

  useEffect(() => {
    if (!displayedFilters.main) {
      form.reset();
    }
  }, [displayedFilters.main, form]);

  if (!displayedFilters.main) return null

  const onSubmit = values => {
    if (Object.keys(values).length > 0) {
      setFilters(values)
    } else {
      hideFilter("main")
    }
  }

  const resetFilter = () => {
    form.reset()
    setFilters({}, [])
  }

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Box display="flex" alignItems="flex-end" mb={1}>
          <Box component="span" mr={2}>
            <TextInput
              resettable
              helperText={false}
              source="q"
              label="搜尋"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon color="disabled" />
                  </InputAdornment>
                )
              }}
            />
          </Box>
          <Box component="span" mr={2}>
            <ReferenceInput source="parentId" 
              reference="categories" 
              filter={{ type: 'product', level: 'top' }}
              sort={{ field: 'sorting', order: 'ASC' }}
            >
              <SelectInput 
                resettable 
                emptyText="全部"
                helperText={false}
                optionText="name" 
                label="父類別" 
              />
            </ReferenceInput>
          </Box>
          <Box component="span" mr={2}>
            <SelectInput
              resettable
              source="status"
              label="啟用狀態"
              emptyText="全部"
              helperText={false}
              choices={[
                { id: 'true', name: '開啟' },
                { id: 'false', name: '關閉' },
              ]}
            />
          </Box>
          <Box component="span" mr={2} mb={1.5}>
            <BooleanInput 
              label="只撈最高層" 
              source="isTopLevel" 
              helperText={false}
            />
          </Box>
          <Box component="span" mr={2} mb={1.5}>
            <Button variant="outlined" color="primary" type="submit">
              篩選
            </Button>
          </Box>
          <Box component="span" mb={1.5}>
            <Button variant="outlined" onClick={resetFilter}>
              關閉
            </Button>
          </Box>
        </Box>
      </form>
    </FormProvider>
  )
}

export default CategoryFilterForm;